export default __webpack_public_path__ + "static/media/hht2_direction_word_play_02.f6c24752.png";